import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionPayPage } from "@/components/subscription/SubscriptionPayPage";
import { parseOutcome } from "@/lib/payment-return-url";

// The emailed pay link. `?status=` is the legacy Monri return (forms opened
// before the path-based `/subscription/pay/<token>/<outcome>`); Monri glues its
// own params onto it with a second `?`, which parseOutcome cuts off.
export const Route = createFileRoute("/subscription/pay/$token")({
  validateSearch: (search: Record<string, unknown>) => ({ status: parseOutcome(search.status) }),
  component: PayRoute,
});

function PayRoute() {
  const { token } = Route.useParams();
  const { status } = Route.useSearch();
  return <SubscriptionPayPage token={token} returnStatus={status} />;
}
